const locale = {
  loadComplete: '加载完成'
};

export default locale;
